export class FetcherError implements Error {
	public readonly name: string = 'Fetcher request error';

	constructor(
		public readonly message: string,
		public readonly url: string,
		public readonly response?: Record<string, any>,
	) {}

	toString() {
		return `${this.name}: ${this.message} (url: ${this.url})`;
	}
}

export class FetcherServerError extends FetcherError {
	public readonly name = 'Fetcher request server error';
	constructor(public readonly code: string, url: string, public readonly response: Record<string, any>) {
		super(`error code: ${code}`, url, response);
	}
}

export class FetcherNetworkError extends FetcherError {
	public readonly name = 'Fetcher request network error';
	constructor(url: string) {
		super('network', url);
	}
}
